import React from 'react'
import { createPortal } from 'react-dom'
import { Toast } from './Toast'
import { ToastNotification } from '../../types/notification'

interface ToastContainerProps {
  toasts: ToastNotification[]
  onRemove: (id: string) => void
}

/** z-[10000] - above all content including modals (z-[9999]) */
const TOAST_Z = 'z-[10000]'

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemove }) => {
  const content = (
    <div
      className={`fixed top-20 right-4 ${TOAST_Z} space-y-2 w-full max-w-sm px-4 sm:pr-4 pointer-events-none`}
      aria-live="polite"
    >
      <div className="pointer-events-auto space-y-2">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            toast={toast}
            onRemove={onRemove}
          />
        ))}
      </div>
    </div>
  )
  return createPortal(content, document.body)
}
